import { ScheduleGateway } from "../domain/schedule.gateway";

export class ResendBillingUseCase {
    constructor(private readonly gate: ScheduleGateway) { }

    async execute(email: string, scheduleId: string): Promise<void> {
        return this.gate.resendBilling(email, scheduleId);
    }
}